import { useEffect, useState } from 'react';
import { apiAssetUrl } from '../lib/api';

interface LogoProps {
  name?: string;
  logoUrl?: string | null;
  compact?: boolean;
}

export function Logo({ name = 'Šihterica', logoUrl, compact = false }: LogoProps) {
  const [imageFailed, setImageFailed] = useState(false);
  const resolvedLogoUrl = apiAssetUrl(logoUrl);
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toLocaleUpperCase('hr-HR') || 'Š';

  useEffect(() => setImageFailed(false), [resolvedLogoUrl]);

  return (
    <div className="brand">
      {resolvedLogoUrl && !imageFailed ? (
        <img
          className="brand__image"
          src={resolvedLogoUrl}
          alt={`${name} logo`}
          onError={() => setImageFailed(true)}
        />
      ) : (
        <span className="brand__mark brand__mark--initials" aria-hidden="true">{initials}</span>
      )}
      {!compact && <span className="brand__name">{name}</span>}
    </div>
  );
}
